import React, { useState, useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get('q');
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!query) {
            setResults([]);
            setIsLoading(false);
            return;
        }

        const fetchResults = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await axios.get(`/api/summary/search?q=${query}`);
                setResults(response.data);
            } catch (err) {
                setError('Failed to fetch search results.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchResults();
    }, [query]);

    const groupedResults = useMemo(() => {
        return results.reduce((acc, item) => {
            const type = item.type;
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(item);
            return acc;
        }, {});
    }, [results]);

    const renderResultGroup = (title, items, type) => {
        if (!items || items.length === 0) return null;

        return (
            <section className="search-result-group">
                <h2 className="section-title">{title} ({items.length})</h2>
                <div className="content-list">
                    {items.map(item => (
                        <Link to={`/${type}s/${item.id}`} key={`${type}-${item.id}`} className="content-card">
                            <img src={item.thumbnail_url} alt={item.title} className="content-card-thumbnail" onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/120x68/16a085/ffffff?text=Image'; }} />
                            <div className="content-card-body">
                                <h3 className="content-card-title">{item.title}</h3>
                                <p className="content-card-description">{item.category}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        );
    };

    return (
        <div className="search-page-container">
            <div className="search-page-header">
                Showing results for: <span className="query-term">"{query}"</span>
            </div>

            {isLoading && <p>Searching...</p>}
            {error && <p className="error-message">{error}</p>}
            
            {!isLoading && !error && results.length === 0 && (
                <div className="no-results-message">
                    <span className="material-icons" style={{ fontSize: '4rem', marginBottom: '1rem' }}>search_off</span>
                    <p>No content found matching your search term.</p>
                </div>
            )}

            {!isLoading && !error && (
                <div>
                    {renderResultGroup('Articles', groupedResults.article, 'article')}
                    {renderResultGroup('Videos', groupedResults.video, 'video')}
                    {renderResultGroup('Podcasts', groupedResults.podcast, 'podcast')}
                    {renderResultGroup('Reels', groupedResults.reel, 'reel')}
                </div>
            )}
        </div>
    );
};

export default SearchPage;
